export const statisticsOptionsWeightAndReps = [
  { label: "Estimated 1RM" },
  { label: "Max Weight" },
  { label: "Max Reps" },
  { label: "Max Volume" },
  { label: "Max Weight for Reps" },
  { label: "Workout Volume" },
  { label: "Workout Reps" },
];

export const statisticsOptionsReps = [
  { label: "Max Reps" },
  { label: "Workout Reps" },
];

export const statisticsOptionsWeight = [{ label: "Max Weight" }];

export const statisticsOptionsDistance = [
  { label: "Max Distance" },
  { label: "Workout Distance" },
];

export const statisticsOptionsTime = [
  { label: "Max Time" },
  { label: "Workout Time" },
];

export const statisticsOptionsWeightAndDistance = [
  { label: "Max Weight" },
  { label: "Max Distance" },
  { label: "Workout Distance" },
];

export const statisticsOptionsWeightAndTime = [
  { label: "Max Weight" },
  { label: "Max Time" },
  { label: "Workout Time" },
];

export const statisticsOptionsRepsAndDistance = [
  { label: "Max Reps" },
  { label: "Max Distance" },
  { label: "Workout Reps" },
  { label: "Workout Distance" },
];

export const statisticsOptionsRepsAndTime = [
  { label: "Max Reps" },
  { label: "Max Time" },
  { label: "Workout Reps" },
  { label: "Workout Time" },
];

export const statisticsOptionsDistanceAndTime = [
  { label: "Max Distance" },
  { label: "Max Time" },
  { label: "Max Speed" },
  { label: "Max Pace" },
  { label: "Workout Distance" },
  { label: "Workout Time" },
];

export const timeframeOptions = [
  { label: "1m", value: "1m" },
  { label: "3m", value: "3m" },
  { label: "6m", value: "6m" },
  { label: "1y", value: "1y" },
  { label: "all", value: "all" },
];

export const intervalOptions = [
  { label: "day", value: "day" },
  { label: "week", value: "week" },
  { label: "month", value: "month" },
  { label: "qtr", value: "quarter" },
  { label: "Year", value: "year" },
];

export const statisticsOptionsMuscleGroups = [
  { label: "Total Reps" },
  { label: "Total Sets" },
  { label: "Total Workouts" },
  { label: "Total Volume" },
];

export const statisticsOptionsBodyTracker = [
  { label: "Body Fat" },
  { label: "Neck" },
  { label: "Shoulders" },
  { label: "Chest" },
  { label: "Left Bicep" },
  { label: "Right Bicep" },
  { label: "Left Forearm" },
  { label: "Right Forearm" },
  { label: "Waist" },
  { label: "Hips" },
  { label: "Left Thigh" },
  { label: "Left Calf" },
  { label: "Right Calf" },
];